import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const titles = [
  "EXCELLENCE",
  "LEGACY",
  "EMPOWER",
  "INSPIRE",
  "THRIVE"
];

const AnimatedTitle: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % titles.length);
    }, 2000); // Change word every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-24 flex items-center justify-center overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.h1
          key={currentIndex}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="text-6xl lg:text-8xl font-black bg-gradient-to-r from-slate-900 via-blue-900 to-emerald-900 bg-clip-text text-transparent"
        >
          {titles[currentIndex]}
        </motion.h1>
      </AnimatePresence>
    </div>
  );
};

export default AnimatedTitle; 